exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button{height:35px;width:140px;background-color:#44567a;color:#fff;padding-left:30px;display:flex;align-items:center;border-radius:2px;transition:all .3s cubic-bezier(0.25, 0.8, 0.25, 1);border:none !important;outline:none !important;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);margin:0}.button:hover{box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);cursor:pointer}.button{position:relative}.button .fas{position:absolute;left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/reusableComponents/CustomButton/customButton.scss
// module id = 1690
// module chunks = 0